<template>
  <v-container>
    <ApexChart height="350" type="bar" :options="chartOptions" :series="series">
    </ApexChart>
  </v-container>
</template>
<script>
import ApexChart from "vue-apexcharts";
export default {
  components: {
    ApexChart,
  },
  name: "Bar",
  // props: ["chartdata"],

  props: {
    customerReportType: {
      required: true,
    },
    customerYear: {
      required: true,
    },
    customerMonth: {
      required: true,
    },
  },
  data() {
    return {
      chartOptions: null,
      series: null,
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },

  created() {
    this.getChartDataYear();
  },

  watch: {
    customerReportType: {
      handler(val) {
        if (val === "Year" && this.customerYear) {
          this.getChartDataYear();
        } else if (val === "Month" && this.customerMonth) {
          this.getChartDataMonth();
        }
      },
    },
    customerYear: {
      handler() {
        this.getChartDataYear();
      },
    },
    customerMonth: {
      handler() {
        this.getChartDataMonth();
      },
    },
  },

  methods: {
    getChartDataMonth() {
      this.$apollo
        .watchQuery({
          query: require("../api/getCustomersByDay.graphql"),
          variables: {
            month: this.customerMonth,
            year: this.customerYear,
          },
        })
        .refetch({
          variables: {
            month: this.customerMonth,
            year: this.customerYear,
          },
        })
        .then((data) => {
          let customers = data.data.getCustomersByDay;
          let graphLabels = new Array();
          let graphCount = new Array();
          customers.forEach((element) => {
            graphLabels.push(element.date);
            graphCount.push(element.count);
          });

          this.chartOptions = {
            chart: {
              id: "macro-bar",
            },
            xaxis: {
              categories: graphLabels,
            },
          };
          this.series = [
            {
              name: "customer",
              data: graphCount,
            },
          ];
        });
    },
    getChartDataYear() {
      this.$apollo
        .watchQuery({
          query: require("../api/getCustomersByMonth.graphql"),
          variables: {
            year: this.customerYear,
          },
        })
        .refetch({})
        .then((data) => {
          let customers = data.data.getCustomersByMonth;
          let graphLabels = new Array();
          let graphCount = new Array();
          customers.forEach((element) => {
            graphLabels.push(element.month);
            graphCount.push(element.count);
          });

          let chartData = {
            labels: graphLabels,
            datasets: [
              {
                label: "Customers",
                backgroundColor: "#000000",
                data: graphCount,
              },
            ],
          };
          this.chartData = chartData;

          this.chartOptions = {
            chart: {
              id: "one-third-bar",
            },
            xaxis: {
              categories: graphLabels,
            },
          };
          this.series = [
            {
              name: "Customers",
              data: graphCount,
            },
          ];
        });
    },
  },
};
</script>
